const projects = [
	{
		id: 1,
		title: "QR Scanner",
		image: "/images/projects/scanner.jpg",
		category: "frontend",
		tags: ["react"],
		url: "https://scan-qrcode.netlify.app/",
		git: [
			{
				title: "Source Code",
				url: "https://github.com/rakibul-islam-raju/React-QR-Generator-And-Scanner",
			},
		],
		extra_images: [
			"/images/projects/qr/qr-generator.png",
			"/images/projects/qr/qr-scanner.png",
		],
		short_description: "React QRcode scanner and generator.",
		technologies: ["React", "Bootstrap", "React-router", "Bootstrap"],
		description: `
### React QR Scanner and Generator
1. User can generate Qr-code from text
2. User can scan any QR-code with phone camera or webcam.
`,
	},
	{
		id: 2,
		title: "Medic",
		image: "/images/projects/medic/cover.png",
		category: "frontend",
		tags: ["react"],
		url: "https://medic-e7005.web.app/",
		git: [
			{
				title: "Source Code",
				url: "https://github.com/rakibul-islam-raju/Medic",
			},
		],
		extra_images: [
			"/images/projects/medic/home.png",
			"/images/projects/medic/doctors.png",
			"/images/projects/medic/banner.png",
		],
		short_description: "React Single page Clinical Website",
		technologies: ["React", "Tailwind", "Firebase", "React-router"],
		description: `
### Medic
1. User can see all the available services
2. Doctor's List with short description
3. Firebase Authentication
3. Responsive for all devices
`,
	},
	{
		id: 3,
		title: "Traveller",
		image: "/images/projects/traveller/cover.png",
		category: "fullstack",
		tags: ["react", "express"],
		url: "https://traveller-e2bb8.web.app/",
		git: [
			{
				title: "Client Code",
				url: "https://github.com/rakibul-islam-raju/Traveller-frontend",
			},
			{
				title: "Server Side",
				url: "https://github.com/rakibul-islam-raju/Traveller-backend",
			},
		],
		extra_images: [
			"/images/projects/traveller/events.png",
			"/images/projects/traveller/blogs.png",
			"/images/projects/traveller/dashboard.png",
		],
		short_description: "Travel event organization website",
		technologies: [
			"React",
			"Tailwind",
			"Firebase",
			"React-router",
			"MongoDB",
		],
		description: `
### Medic

1. User can subscribe and unsubscribe an event and 
2. Admin can approve user's subscription
3. Admin also can post new blog and event
4. User must login to subscribe any event
5. Responsive for all devices
`,
	},
	{
		id: 4,
		title: "Chairfull",
		image: "/images/projects/chairfull/cover.png",
		category: "fullstack",
		tags: ["react", "express"],
		url: "https://chairfull-6632f.web.app/",
		git: [
			{
				title: "Client Code",
				url: "https://github.com/rakibul-islam-raju/Chairfull-Frontend",
			},
			{
				title: "Server Side",
				url: "https://github.com/rakibul-islam-raju/Chairfull-Backend",
			},
		],
		extra_images: [
			"/images/projects/chairfull/shop.png",
			"/images/projects/chairfull/dashboard.png",
			"/images/projects/chairfull/admin.png",
		],
		short_description: "A niche e-commerce website",
		technologies: [
			"React",
			"Express",
			"MongoDB",
			"Tailwind",
			"Firebase",
			"React-router",
		],
		description: `
### Chairfull

1. User can order products
2. User can also give review
3. Admin can update uctomer's order status
4. Admin cand add new product from dashboard
5. Admin can add another admin
6. Multiple role based authenticaiton
7. Responsive for all devices
`,
	},
	{
		id: 5,
		title: "Sales Manager",
		image: "/images/projects/sales-manager/cover.png",
		category: "fullstack",
		tags: ["django"],
		url: "https://djsales-manager.herokuapp.com/",
		git: [
			{
				title: "Source Code",
				url: "https://github.com/rakibul-islam-raju/Sales-Manager",
			},
		],
		extra_images: [
			"/images/projects/sales-manager/login.png",
			"/images/projects/sales-manager/chart.png",
			"/images/projects/sales-manager/summary.png",
			"/images/projects/sales-manager/users.png",
		],
		short_description: "Sales Management Application",
		technologies: ["Django", "Javascript", "Bootstrap"],
		description: `
### Sales Manager

1. The sales management system is focused to keeps records of daily sales and
calculating the summary.
2. The admin will be registered under an office & other staff can easily create their
account. They must confirm their email & the admin will approve their account.
3. Users can calculate the summary of purchases and sales and can download the
summary and invoices.
`,
	},
	{
		id: 6,
		title: "Inventory Management",
		image: "/images/projects/inventory/cover.png",
		category: "fullstack",
		tags: ["django"],
		url: "https://dj-inventory-management-system.herokuapp.com/",
		git: [
			{
				title: "Source Code",
				url: "https://github.com/rakibul-islam-raju/Django-inventory",
			},
		],
		extra_images: [
			"/images/projects/inventory/login.png",
			"/images/projects/inventory/products.png",
			"/images/projects/inventory/dashboard.png",
			"/images/projects/inventory/profile.png",
		],
		short_description: "Inventory Management Application",
		technologies: ["Django", "Javascript", "Bootstrap"],
		description: `
### Inventory Management

1. Build with Django web framework where customers can order products.
2. Users must confirm their email with the email verification link to register a new
account. Or only superusers can approve their email from the control panel.
3. An admin will be registered under an organization. Admin can add staff and
manage their roles. User roles are - Superuser, Staff, and Customer
4. Staff can purchase and sell products and manage customers’ orders.
`,
	},
	{
		id: 7,
		title: "Ecommerce",
		image: "/images/projects/ecommerce/cover.png",
		category: "fullstack",
		tags: ["django", "react"],
		// url: "https://dj-inventory-management-system.herokuapp.com/",
		git: [
			{
				title: "Source Code",
				url: "https://github.com/rakibul-islam-raju/Ecommerce-with-DJANGO-REACT",
			},
		],
		extra_images: [
			"/images/projects/ecommerce/cover.png",
			"/images/projects/ecommerce/first.png",
			"/images/projects/ecommerce/second.png",
			"/images/projects/ecommerce/third.png",
		],
		short_description: "Single page ecommerce application",
		technologies: [
			"Django",
			"DRF",
			"React",
			"Redux",
			"React-Bootstrap",
			"Paypal-Payment",
		],
		description: `
### Ecommerce

1. An eCommerce application with basic cart, order, payment features.
2. An admin dashboard is available for controlling the application.
3. Users can review products only if they buy one.
4. Admin can manage all products, users, orders.
`,
	},
];

export default projects;
